import React from "react";
import TextInput from "../../../../Components/Inputs/TextInput";
import TextareaInput from "../../../../Components/Inputs/TextareaInput";

export default function ({register, errors, watch}) {

  return (
    <>
      <TextInput
        label="First Name"
        name="shippingAddress.first_name"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.['shippingAddress.first_name']}
      />
      <TextInput
        label="Last Name"
        name="shippingAddress.last_name"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.['shippingAddress.last_name']}
      />
      <TextInput
        label="Personal Number"
        name="shippingAddress.personal_number"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.['shippingAddress.personal_number']}
      />
      <TextInput
        label="Phone"
        name="shippingAddress.phone"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.['shippingAddress.phone']}
      />
      <TextInput
        label="Address"
        name="shippingAddress.address"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.['shippingAddress.address']}
      />
      <TextInput
        label="Address Type"
        name="shippingAddress.address_type"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.['shippingAddress.address_type']}
      />
      <TextareaInput
        label="Comment"
        name="shippingAddress.comment"
        className="col-12"
        register={register}
        watch={watch}
        errorMessage={errors?.['shippingAddress.comment']}
      />
    </>
  );
}